import { ProcessLocationTypeDto } from '@/api/generated';

export type CreateProcessTranslation = {
  buttons: {
    close: string;
    next: string;
    startAnalysis: string;
  };
  content: {
    budget: {
      budgetValueLabel: string;
      budgetValuePlaceholder: string;
      percentageToleranceLabel: string;
      percentageTolerancePlaceholder: string;
      title: string;
    };
    location: {
      locationTypeLabel: string;
      locationTypePlaceholder: string;
      locationValueLabel: string;
      locationValuePlaceholder: string;
      title: string;
    };
    recruitmentDetails: {
      extendedAtsIntegration: string;
      recruitmentIdLabel: string;
      recruitmentIdPlaceholder: string;
      recruitmentNameLabel: string;
      recruitmentNamePlaceholder: string;
      recruitmentType: string;
      selectTemplate: string;
      title: string;
    };
    redFlags: {
      addNewRedFlag: string;
      infotip: string;
      newRedFlagsPlaceholder: string;
      title: string;
    };
    requirements: {
      requirementsLabel: string;
      requirementsPlaceholder: string;
      title: string;
    };
  };
  locationTypes: Record<ProcessLocationTypeDto, string>;
  recruitmentTypes: Record<string, string>;
  start: {
    accepted: string;
    errors: {
      conflict: string;
      default: string;
      forbidden: string;
      missingRequirements: string;
      notFound: string;
    };
  };
  title: {
    edit: string;
    start: string;
  };
};

export const createProcessTranslation: CreateProcessTranslation = {
  buttons: {
    close: 'Close',
    next: 'Next',
    startAnalysis: 'Start analysis',
  },
  content: {
    budget: {
      budgetValueLabel: 'Max value',
      budgetValuePlaceholder: 'Max value',
      percentageToleranceLabel: 'Percentage tolerance [%]',
      percentageTolerancePlaceholder: 'write value in %',
      title: 'Budget',
    },
    location: {
      locationTypeLabel: 'Type',
      locationTypePlaceholder: 'choose option',
      locationValueLabel: 'eRecruiter location',
      locationValuePlaceholder: 'provide location',
      title: 'Location',
    },
    recruitmentDetails: {
      extendedAtsIntegration: 'Extended integration',
      recruitmentIdLabel: 'Recruitment ID',
      recruitmentIdPlaceholder: 'provide eRecruiter recruitment process ID if available',
      recruitmentNameLabel: 'Recruitment name',
      recruitmentNamePlaceholder: 'write the name',
      recruitmentType: 'Recruitment type',
      selectTemplate: 'Select a template...',
      title: 'Recruitment Details',
    },
    redFlags: {
      addNewRedFlag: 'Add new red flag',
      infotip:
        'List the red flags in the field below that should be considered when analyzing the requirements of the process.',
      newRedFlagsPlaceholder: 'write the red flag',
      title: 'Red Flags',
    },
    requirements: {
      requirementsLabel: 'Description',
      requirementsPlaceholder: 'write or paste here job description',
      title: 'Requirements',
    },
  },
  locationTypes: {
    [ProcessLocationTypeDto.Hybrid]: 'Hybrid',
    [ProcessLocationTypeDto.Office]: 'Office',
    [ProcessLocationTypeDto.Remote]: 'Remote',
  },
  recruitmentTypes: {
    B2C: 'B2C',
    REGULAR: 'Regular',
  },
  start: {
    accepted: 'Analysis started. The process is being prepared in the background.',
    errors: {
      conflict: 'This process has already been started or closed. Refreshing its state.',
      default: 'The process could not be started. Please try again.',
      forbidden: 'This process is owned by another user and cannot be started here.',
      missingRequirements: 'Job description is required to start the analysis.',
      notFound: 'This process no longer exists.',
    },
  },
  title: {
    edit: 'Edit process',
    start: 'Configure and start analysis',
  },
};
